import { useState, useEffect, useRef } from "react";
import { capitalizeAndCleanUnderscore } from "@utils";

const useHyroMultiSelect = ({ value, options, onFocus, onBlur, onPopperClose, open }) => {

  const [menuOpen, setMenuOpen] = useState(open);
  const inputRef = useRef(null);
  useEffect(() => {
    if (menuOpen) {
      onFocus?.(inputRef.current);
    } else {
      onPopperClose?.();
    }
  }, [menuOpen, onFocus, onPopperClose]);
  const getLocalValues = () => {
    // if value comes as a list of strings (happens in inline table editing) then we want to turn the local values into a list of objects
    if (value && value.length > 0 && typeof value[0] === "string") {
      return value?.map((val) => options.find(({ key, display_key }) => key.toLowerCase() === val.toLowerCase() || display_key.toLowerCase() === val.toLowerCase())).filter(Boolean);
    }

    if (typeof value === "string") value = [];

    return value;
  };

  const localValue = getLocalValues();
  const textValues = localValue?.map((valueItem) => capitalizeAndCleanUnderscore(valueItem?.display_key)) || [];

  const handleBlur = () => {
    onBlur?.();
    setMenuOpen(false);
  };

  const handleFocus = () => {
    setMenuOpen(true);
  };

  return {
    localValue,
    textValues,
    inputRef,
    menuOpen,
    handleBlur,
    handleFocus
  };
};

export default useHyroMultiSelect;
